import { render, staticRenderFns } from "./FloatImage.vue?vue&type=template&id=62468522"
import script from "./FloatImage.vue?vue&type=script&lang=js"
export * from "./FloatImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports